import React from 'react';
import { Modal, Form, Input, Radio, message } from 'antd';

interface IProps {
  showModal: boolean;
  onModalOk(values: any): void;
  closeModal(): void;
}

function SignModal(props: IProps) {
  const { showModal, onModalOk, closeModal } = props;
  const [ form ] = Form.useForm();
  // 输入合格
  const onFinish = (values: any) => {
    // 去除underfined情况
    Object.keys(values).forEach(key => {
      if (!values[key]) {
        values[key] = "";
      }
    })
    onModalOk(values);
  };
  // 未输入完成
  const onFinishFailed = () => {
    message.info("请完善信息");
  };
  // 模态框确定
  function onOk() {
    form.submit();
  }
  // 验证邮箱
  const validatorEmail = (rule: any, value: string) => {
    const reg = new RegExp("^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$");
    if (value && !reg.test(value)) {
      return Promise.reject("请输入正确的邮箱");
    }
    return Promise.resolve();
  }
  // 验证身份证
  const validatorIdcard = (rule: any, value: string) => {
    const reg = /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
    if (value && !reg.test(value)) {
      return Promise.reject("请输入正确的身份证号");
    }
    return Promise.resolve();
  }
  // 验证手机号
  const validatorPhone = (rule: any, value: string) => {
    const reg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/;
    if (value && !reg.test(value)) {
      return Promise.reject("请输入正确的手机号");
    }
    return Promise.resolve();
  }
  // 布局
  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 16 },
  };

  return (
    <Modal
      visible={showModal}
      title="考试报名"
      onOk={onOk}
      onCancel={closeModal}
    >
      <Form
        {...layout}
        name="basic"
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label="用户名"
          name="user_name"
          rules={[{ required: true, message: '请输入用户名' }]}
        >
          <Input allowClear placeholder="请输入用户名" />
        </Form.Item>

        <Form.Item
          label="性别"
          name="gender"
          rules={[{ required: false, message: '请选择性别' }]}
        >
          <Radio.Group>
            <Radio value="男">男</Radio>
            <Radio value="女">女</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="身份证号"
          name="id_card"
          rules={[{ required: true, message: '请输入身份证号' }, { validator: validatorIdcard}]}
        >
          <Input allowClear placeholder="请输入身份证号" />
        </Form.Item>
        <Form.Item
          label="邮箱"
          name="email"
          rules={[{ required: true, message: '请输入邮箱' }, {validator: validatorEmail}]}
        >
          <Input allowClear placeholder="请输入邮箱" />
        </Form.Item>
        <Form.Item
          label="公司名称"
          name="company"
          rules={[{ required: true, message: '请输入公司名称' }]}
        >
          <Input allowClear placeholder="请输入公司名称" />
        </Form.Item>
        <Form.Item
          label="部门"
          name="department"
          rules={[{ required: false, message: '请输入部门' }]}
        >
          <Input allowClear placeholder="请输入部门" />
        </Form.Item>
        <Form.Item
          label="职位"
          name="position"
          rules={[{ required: false, message: '请输入职位' }]}
        >
          <Input allowClear placeholder="请输入职位" />
        </Form.Item>
        <Form.Item
          label="联系方式"
          name="phone"
          rules={[{ required: true, message: '请输入联系方式' }, {validator: validatorPhone}]}
        >
          <Input allowClear placeholder="请输入联系方式" />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default SignModal;
